// src/components/ui/Pagination.jsx
import React from "react";
import "../../styles/pagination.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];

  // 페이지 번호 생성 (최대 5개 표시)
  const startPage = Math.max(1, currentPage - 2);
  const endPage = Math.min(totalPages, startPage + 4);

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const getStrokeColor = (isDisabled) => {
    return isDisabled ? "#ddd" : "#aaa";
  };

  return (
    <div className="pagination">
      {/* 맨 처음으로 버튼 */}
      <button className="pagination-arrow" onClick={() => onPageChange(1)} disabled={currentPage === 1}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.413" height="16.826" viewBox="0 0 16.413 16.826">
          <g data-name="그룹 53">
            <path
              data-name="패스 42"
              d="M6.533 0 0 7l6.533 7"
              transform="translate(8.467 1.414)"
              style={{
                strokeLinejoin: "round",
                fill: "none",
                stroke: getStrokeColor(currentPage === 1),
                strokeLinecap: "round",
                strokeWidth: "2px",
              }}
            />
            <path
              data-name="선 47"
              transform="translate(1 1.413)"
              style={{
                fill: "none",
                stroke: getStrokeColor(currentPage === 1),
                strokeLinecap: "round",
                strokeWidth: "2px",
              }}
              d="M0 0v14"
            />
          </g>
        </svg>
      </button>

      {/* 이전 페이지 버튼 */}
      <button className="pagination-arrow" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16">
          <path
            d="M8 0L0 8l8 8"
            transform="translate(1 0)"
            style={{
              strokeLinejoin: "round",
              fill: "none",
              stroke: getStrokeColor(currentPage === 1),
              strokeLinecap: "round",
              strokeWidth: "2px",
            }}
          />
        </svg>
      </button>

      {/* 페이지 번호 */}
      {pageNumbers.map((number) => (
        <button key={number} className={`pagination-number ${currentPage === number ? "active" : ""}`} onClick={() => onPageChange(number)}>
          {number}
        </button>
      ))}

      {/* 다음 페이지 버튼 */}
      <button className="pagination-arrow" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" style={{ transform: "rotate(180deg)" }}>
          <path
            d="M8 0L0 8l8 8"
            transform="translate(1 0)"
            style={{
              strokeLinejoin: "round",
              fill: "none",
              stroke: getStrokeColor(currentPage === totalPages),
              strokeLinecap: "round",
              strokeWidth: "2px",
            }}
          />
        </svg>
      </button>

      {/* 맨 끝으로 버튼 */}
      <button className="pagination-arrow" onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.413" height="16.826" viewBox="0 0 16.413 16.826" style={{ transform: "rotate(180deg)" }}>
          <g data-name="그룹 53">
            <path
              data-name="패스 42"
              d="M6.533 0 0 7l6.533 7"
              transform="translate(8.467 1.414)"
              style={{
                strokeLinejoin: "round",
                fill: "none",
                stroke: getStrokeColor(currentPage === totalPages),
                strokeLinecap: "round",
                strokeWidth: "2px",
              }}
            />
            <path
              data-name="선 47"
              transform="translate(1 1.413)"
              style={{
                fill: "none",
                stroke: getStrokeColor(currentPage === totalPages),
                strokeLinecap: "round",
                strokeWidth: "2px",
              }}
              d="M0 0v14"
            />
          </g>
        </svg>
      </button>
    </div>
  );
};

export default Pagination;
